import { render, staticRenderFns } from "./StateGovernmentCheck.vue?vue&type=template&id=0f1d6efa&scoped=true&"
import script from "./StateGovernmentCheck.vue?vue&type=script&lang=js&"
export * from "./StateGovernmentCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1d6efa",
  null
  
)

export default component.exports